export default __webpack_public_path__ + "static/media/right_shrubs.80ceceeb.svg";